import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { UserRemoveIcon } from '@repo/ui/icons'
import Modal, { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { cancelAffectedStaff } from '../../../../api/affected-staffs/cancel-staff'
import { useObserver } from '../../../../lib/contexts/observer'
import { CancelAffectedStaffResponse } from '../../../../lib/types/models/affectedStaff/affected-staff'
import { showAxiosError } from '../../../../lib/utils/functions/misc.functions'
import CancelAffectedStaffForm from './cancel-affected-staff-form'

type Props = {
  title?: string
  affectedStaffIds: number[]
  isOpen: boolean
  onCancel: () => void
  onSuccess?: (response: CancelAffectedStaffResponse) => void
}

const CancelAffectedStaffModal = ({
  title,
  affectedStaffIds,
  isOpen,
  onCancel,
  onSuccess
}: Props) => {
  const staffRequestObserver = useObserver({ key: 'staff-requests' })

  const deaffectStaffMutation = useMutation({
    mutationFn: cancelAffectedStaff,
    onError: showAxiosError,
    onSuccess: (response) => {
      toast.success('Encadrant désaffecté avec succès')
      staffRequestObserver.notify(['affected-staffs'])
      // the modal is already closed on confirm: closing again would re-toggle it for the callers
      onSuccess?.(response)
    }
  })

  return (
    <Modal
      isOpen={isOpen}
      icon={UserRemoveIcon}
      variant="destructive"
      size="small"
      title={title}
      hasBorderBottom={false}
      hideActions
      onCancel={onCancel}
    >
      <>
        <Typography
          variant={'body-medium'}
          className={'text-center'}
          color={tailwindColors.grey.DEFAULT}
        >
          Sélectionner la raison de la désaffectation
        </Typography>
        <CancelAffectedStaffForm
          className={MODAL_CONTENT_CLASSNAME}
          onCancel={onCancel}
          onConfirm={(values) => {
            deaffectStaffMutation.mutate({ ...values, affectedStaffIds })
            onCancel()
          }}
          loading={deaffectStaffMutation.isPending}
        />
      </>
    </Modal>
  )
}

export default CancelAffectedStaffModal
